/* eslint-disable @typescript-eslint/no-var-requires */
import faPlus from '@fortawesome/fontawesome-pro/svgs/regular/plus.svg';
import faXMark from '@fortawesome/fontawesome-pro/svgs/regular/xmark.svg';
import faTrashCan from '@fortawesome/fontawesome-pro/svgs/regular/trash-can.svg';
import faAngleLeft from '@fortawesome/fontawesome-pro/svgs/solid/angle-left.svg';
import faAngleRight from '@fortawesome/fontawesome-pro/svgs/solid/angle-right.svg';
import faAngleUp from '@fortawesome/fontawesome-pro/svgs/solid/angle-up.svg';
import faAngleDown from '@fortawesome/fontawesome-pro/svgs/solid/angle-down.svg';
import faCheck from '@fortawesome/fontawesome-pro/svgs/regular/check.svg';
import faArrowRight from '@fortawesome/fontawesome-pro/svgs/regular/arrow-right.svg';
import faArrowLeft from '@fortawesome/fontawesome-pro/svgs/regular/arrow-left.svg';
import faPencil from '@fortawesome/fontawesome-pro/svgs/regular/pencil.svg';
import faInfo from '@fortawesome/fontawesome-pro/svgs/solid/info.svg';
import faQuestion from '@fortawesome/fontawesome-pro/svgs/solid/question.svg';
import faMagnifyingGlass from '@fortawesome/fontawesome-pro/svgs/regular/magnifying-glass.svg';
import faFilter from '@fortawesome/fontawesome-pro/svgs/solid/filter.svg';
import faArrowRightToBracket from '@fortawesome/fontawesome-pro/svgs/solid/arrow-right-to-bracket.svg';
import faArrowRightFromBracket from '@fortawesome/fontawesome-pro/svgs/solid/arrow-right-from-bracket.svg';
import faUser from '@fortawesome/fontawesome-pro/svgs/solid/user.svg';
import faPaperclip from '@fortawesome/fontawesome-pro/svgs/regular/paperclip.svg';
import faGear from '@fortawesome/fontawesome-pro/svgs/solid/gear.svg';
import faSquarePlus from '@fortawesome/fontawesome-pro/svgs/solid/square-plus.svg';
import faSquareMinus from '@fortawesome/fontawesome-pro/svgs/solid/square-minus.svg';
export default {
    create: faPlus,
    add: faPlus,
    edit: faPencil,
    remove: faXMark,
    delete: faTrashCan,
    expand: faSquarePlus,
    collapse: faSquareMinus,
    'toggle-left': faAngleLeft,
    'toggle-right': faAngleRight,
    'toggle-up': faAngleUp,
    'toggle-down': faAngleDown,
    confirm: faCheck,
    save: faCheck,
    cancel: faXMark,
    'drill-down': faArrowRight,
    'go-back': faArrowLeft,
    info: faInfo,
    help: faQuestion,
    search: faMagnifyingGlass,
    filter: faFilter,
    close: faXMark,
    'sign-in': faArrowRightToBracket,
    'sign-out': faArrowRightFromBracket,
    person: faUser,
    attachment: faPaperclip,
    attachments: faPaperclip,
    setting: faGear,
    settings: faGear,
    administration: faGear,
    administrate: faGear
};
